import React from 'react';

const ImagePopup = (props) => {
    return (
        <div onClick={props.closePopup} className={`popup ${props.cardLink && 'popup_opened'}`}>
            <figure>
                <img className="popup__image" src={props.cardLink}
                     alt="приближенная картинка"
                     onClick={(e) => e.stopPropagation()} />
            </figure>
        </div>
    );
};

export default ImagePopup;